// src/i18n/translations.js
// Copia bilingüe (ES/EN) del sitio público. Extraído de App.js para que el
// componente de routing no cargue el diccionario completo de textos.
const translations = {
  es: {
    nav: ['Inicio', 'Servicios', 'Quiénes somos', 'Equipo', 'Clientes', 'Contacto'],
    heroSubtitle: 'Servicios Administrativos Especializados',
    heroTitle: 'Eficiencia en',
    heroTitleSpan: 'Gestión Operativa',
    heroDesc: 'Soporte estratégico para Public Adjusters, Abogados y Compañías de Restauración en Florida.',
    heroBtn: 'Hablemos ahora',
    servicesTitle: 'Nuestros Servicios',
    services: [
      { title: 'Asistencia de Reclamos', desc: 'Gestión técnica de documentos, reportes de daños y coordinación directa con aseguradoras.' },
      { title: 'Asistente Personal', desc: 'Soporte administrativo ejecutivo, manejo de agenda, correos y organización operativa.' },
      { title: 'Marketing Digital', desc: 'Creación de contenido estratégico y gestión de comunidades para potenciar tu firma.' },
      { title: 'Customer Service', desc: 'Atención al cliente de primer nivel, seguimiento de llamadas y soporte bilingüe.' },
      { title: 'Análisis y Reportes', desc: 'Optimización de procesos internos y análisis de datos para mejorar eficiencia.' }
    ],
    aboutTitle: 'Tu Aliado Estratégico',
    aboutSpan: 'en el Estado de Florida',
    aboutDesc1: 'En CSR Claims Assistant somos el aliado estratégico de Tasadores Públicos, Compañías de Restauración y Abogados. Nuestro propósito es sencillo: hacer que tu trabajo sea más efectivo, dinámico y rápido.',
    aboutDesc2: 'Reducimos tu carga operativa y te ayudamos a enfocarte en lo que realmente importa: tus clientes.',
    teamTitle: 'Nuestro Equipo',
    clientsTitle: 'Empresas Aliadas',
    contactTitle: 'Hablemos',
    contactDesc: 'Optimiza tu operativa hoy mismo. Déjanos tus datos y nos pondremos en contacto.',
    formName: 'Nombre Completo',
    formEmail: 'Correo Electrónico',
    formSubject: 'Asunto',
    formMessage: '¿Cómo podemos ayudarte?',
    submitBtn: 'ENVIAR MENSAJE',
    footerDesc: 'Soporte administrativo y estratégico especializado para el sector de reclamos en Florida.',
    efficiencyTitle: 'Mejora tu Eficiencia Operativa',
    dashboard: 'Panel',
    claimStatus: 'Estado Reclamo',
    admin: 'Login'
  },
  en: {
    nav: ['Home', 'Services', 'About Us', 'Team', 'Clients', 'Contact'],
    heroSubtitle: 'Specialized Administrative Services',
    heroTitle: 'Efficiency in',
    heroTitleSpan: 'Operational Management',
    heroDesc: 'Strategic support for Public Adjusters, Attorneys, and Restoration Companies in Florida.',
    heroBtn: "Let's talk now",
    servicesTitle: 'Our Services',
    services: [
      { title: 'Claims Assistance', desc: 'Technical document management, damage reports, and direct coordination with insurance companies.' },
      { title: 'Personal Assistant', desc: 'Executive administrative support, schedule management, emails, and operational organization.' },
      { title: 'Digital Marketing', desc: 'Strategic content creation and community management to boost your firm.' },
      { title: 'Customer Service', desc: 'First-level customer service, call tracking, and bilingual support.' },
      { title: 'Analysis & Reports', desc: 'Internal process optimization and data analysis to improve efficiency.' }
    ],
    aboutTitle: 'Your Strategic Ally',
    aboutSpan: 'in the State of Florida',
    aboutDesc1: 'At CSR Claims Assistant, we are the strategic ally for Public Adjusters, Restoration Companies, and Attorneys. Our purpose is simple: to make your work more effective, dynamic, and fast.',
    aboutDesc2: 'We reduce your operational burden and help you focus on what really matters: your clients.',
    teamTitle: 'Our Team',
    clientsTitle: 'Partner Companies',
    contactTitle: "Let's Talk",
    contactDesc: 'Optimize your operations today. Leave us your details and we will get in touch.',
    formName: 'Full Name',
    formEmail: 'Email Address',
    formSubject: 'Subject',
    formMessage: 'How can we help you?',
    submitBtn: 'SEND MESSAGE',
    footerDesc: 'Specialized administrative and strategic support for the claims sector in Florida.',
    efficiencyTitle: 'Improve Your Operational Efficiency',
    dashboard: 'Dashboard',
    claimStatus: 'Claim Status',
    admin: 'Login'
  }
};

export default translations;
